import { render } from "./RdPopper.vue?vue&type=template&id=4c4e783d&scoped=true&ts=true"
import script from "./RdPopper.vue?vue&type=script&lang=ts"
export * from "./RdPopper.vue?vue&type=script&lang=ts"

import "./RdPopper.vue?vue&type=style&index=0&id=4c4e783d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4e783d"]])

export default __exports__